import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import { formatReviewText } from '../../utils/formatText';
import { useTheme, useMediaQuery } from '@mui/material';

interface ReviewPreviewDialogProps {
  open: boolean;
  onClose: () => void;
  reviewText: string;
}

const ReviewPreviewDialog: React.FC<ReviewPreviewDialogProps> = ({
  open,
  onClose,
  reviewText
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={fullScreen}
      PaperProps={{
        elevation: 1,
        sx: {
          backgroundColor: 'rgba(20, 20, 20, 1)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: { xs: 0, md: '12px' },
          ...(fullScreen ? {} : {
            margin: '32px',
            maxWidth: '600px',
            maxHeight: 'calc(100% - 64px)',
          }),
        },
      }}
    >
      <DialogTitle>プレビュー</DialogTitle>
      <DialogContent>
        <Box sx={{ my: 2, color: 'pulse.text', fontSize: fullScreen ? '0.7rem' : '0.8rem' }}>
          {formatReviewText(reviewText, fullScreen)}
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          py: 1.5,
          pb: fullScreen ? 'calc(8px + env(safe-area-inset-bottom))' : 1.5,
        }}
      >
        <Button onClick={onClose} color="primary" size="small">閉じる</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReviewPreviewDialog; 